module.exports = __webpack_public_path__ + "static/media/Drawer-light.7a2289ee.png";